import { GlobalElementsProvider } from '@/platform-web/next-global-elements/src'

export function TelusGlobalElements({ children }) {
  return <GlobalElementsProvider>{children}</GlobalElementsProvider>
}
